import React, { useContext } from "react";

import { Route } from "react-router-dom";

import { AuthContext } from "../contexts/Auth"
import AuthFlow from "../components/AuthFlow"

// non-exported component which displays message (modififiable by prop) that the
// user does not have staff privileges
const NotStaff = ({ msg = "Staff Privileges are required to access this page."}) => {
    return (
        <div>
            {msg}
        </div>
    )
}

const StaffRoute = ({ component: RouteComponent, authFlowLayout: Layout, ...rest }) => {
    const { isAuthenticated, isStaff, emailVerified } = useContext(AuthContext)

    if (isStaff && emailVerified) {
        // user is logged in and is staff. proceed normally, wrap as normal route as RouteComponent
        // may be depending on standard props passed to routes
        return (
            <Route
                {...rest}
                render={routeProps => (
                    <RouteComponent {...routeProps} />
                )}
            />
        )

    } else if (isAuthenticated && emailVerified) {
        // display message that the user needs a staff privileges to access this page
        if (Layout) {
            return (
                <Route
                    {...rest}
                    render={routeProps => (
                        <Layout {...routeProps}>
                            <NotStaff />
                        </Layout>
                        )}
                />
            )
        } else {
            return <NotStaff />
        }
    } else {
        if (Layout) {
            // return AuthFlow embeded within provided layout
            return (
                <Route
                    {...rest}
                    render={routeProps => (
                        <Layout {...routeProps} >
                            <AuthFlow {...rest} />
                        </Layout>
                    )}
                />
            )
        } else {
            // simply return AuthFlow with out any wrapping layout
            return (
                <Route
                    {...rest}
                    render={routeProps => (
                        <AuthFlow {...rest} />
                    )}
                />
            )
        }
    }
}


export default StaffRoute